export default {
  'hero.tagline': 'Global Data Infrastructure',
  'hero.mainTitle': '让数据回归核心',
  'hero.subTitle': 'Data Returns to the Axis',
  'hero.description': '从底层存储芯片到顶层系统架构，AX Axis 重塑数据生态，让每一份数据在安全、高效、智能的"轴心"上流转。',
  'hero.cta': '探索生态体系',
  'hero.brandIdentifier': 'AX AXIS INTERNATIONAL HOLDING LIMITED',

  'identity.label': 'Identity & Vision',
  'identity.companyName': '艾思国际控股有限公司',
  'identity.vision': '成为全球领先的私域数据生态构建者，让每一份数据都能在安全、高效、智能的"轴心"上流转。',
  'identity.description': '我们是一家专注于高性能存储解决方案与网络基建的领先供应商。我们致力于为企业及个人用户提供从底层芯片到顶层架构的全链路数据支持。',
  'identity.feature1.title': '安全',
  'identity.feature1.desc': '端到端数据安全保障',
  'identity.feature2.title': '高效',
  'identity.feature2.desc': '企业级数据传输',
  'identity.feature3.title': '智能',
  'identity.feature3.desc': '本地化 AI 处理',
  'identity.cta': '了解品牌故事',

  'business.title': '核心业务',
  'business.subtitle': '三大引擎',
  'business.chipTrade.name': '存储芯片国际贸易',
  'business.chipTrade.nameEn': 'Global Chip Trade',
  'business.chipTrade.desc': '我们专注于 NAND Flash 与 DRAM 颗粒的全球进出口业务。凭借深厚的行业积累，AX Axis 与全球主要原厂及经销体系建立了稳固的配额合作关系，确保在市场波动中为客户提供稳定的现货供应与极具竞争力的价格。',
  'business.chipTrade.spec': 'NAND / DRAM',
  'business.consumerBrand.name': '自营高性能存储品牌',
  'business.consumerBrand.nameEn': 'Consumer Storage Brand',
  'business.consumerBrand.desc': 'AX Axis 致力于将硬核技术与极简工业美学相结合。我们的产品线涵盖高性能移动硬盘、高速 SD/TF 存储卡及企业级 SSD 终端。每一件产品都代表了我们对效能的极致追求与对设计美学的坚持。',
  'business.consumerBrand.spec': 'SSD / SD / HDD',
  'business.aiNAS.name': 'AI NAS 智能系统',
  'business.aiNAS.nameEn': 'Axis OS',
  'business.aiNAS.desc': 'Axis OS 是我们自主研发的核心软件生态。作为一款专为 AI 时代设计的智能存储系统，它为企业及家庭提供「军用级加密」的本地私有云解决方案。通过零配置内网穿透与极致的用户交互体验，让数据资产在绝对安全的前提下，实现跨地域的无缝协同。',
  'business.aiNAS.spec': 'Axis OS / AI Ready',

  'strategy.label': 'Strategic Positioning',
  'strategy.title': '战略定位',
  'strategy.subtitle': '香港研发，全球生态 —— 构建稳固的商业架构，以香港为核心动力引擎',
  'strategy.hk.title': '扎根香港',
  'strategy.hk.subtitle': 'Rooted in Hong Kong',
  'strategy.hk.desc': '拥有专属香港研发团队，专注于 AX Axis 产品的研发。',
  'strategy.hk.points.0': 'Axis OS 自主研发',
  'strategy.hk.points.1': '知识产权保护',
  'strategy.hk.points.2': '国际品牌背书',
  'strategy.hk.tag': '香港研发中心',
  'strategy.cn.title': '背靠内地',
  'strategy.cn.subtitle': 'Powered by Mainland China',
  'strategy.cn.desc': '深度整合大湾区及内地领先的电子制造产业链，确保高效交付与成本控制。',
  'strategy.cn.points.0': '半导体封装测试',
  'strategy.cn.points.1': '高效供应链整合',
  'strategy.cn.points.2': '大湾区制造优势',
  'strategy.cn.tag': '制造供应链',
  'strategy.global.title': '面向全球',
  'strategy.global.subtitle': 'Global Market Focus',
  'strategy.global.desc': '以香港为支点，通过国际物流与多语言服务，将存储解决方案输出至全球市场。',
  'strategy.global.points.0': '国际物流体系',
  'strategy.global.points.1': '多语言技术支持',
  'strategy.global.points.2': '全球市场渗透',
  'strategy.global.tag': '全球市场拓展',

  'advantage.title': 'AX 的护城河',
  'advantage.subtitle': '自主 OS · 全链路研发 · 香港品牌 · 极致工业美学',
  'advantage.item1.title': '自主系统护城河',
  'advantage.item1.desc': '香港研发团队打造的 Axis OS，确保系统层面的绝对自主权与全球领先的安全性。',
  'advantage.item2.title': '全链路研发能力',
  'advantage.item2.desc': '从底层颗粒到系统固件再到最终用户界面，实现深度垂直整合。',
  'advantage.item3.title': '国际化品牌红利',
  'advantage.item3.desc': '香港本土品牌的国际化形象更易获得全球高端及政企用户的信任。',
  'advantage.item4.title': '极致工业美学',
  'advantage.item4.desc': '通过特斯拉风格的视觉语言，吸引追求生活品质的高端受众。',

  'roadmap.label': 'Roadmap',
  'roadmap.title': '发展路线图',
  'roadmap.description': '2021 — 2026 关键里程碑，从香港出发，重塑全球数据新标准',
  'roadmap.milestone1.quarter': '2021',
  'roadmap.milestone1.title': '公司于香港正式成立',
  'roadmap.milestone1.desc': '在香港正式成立，定位为存储芯片国际贸易商。',
  'roadmap.milestone2.quarter': '2022 - 2023',
  'roadmap.milestone2.title': '全球贸易启动',
  'roadmap.milestone2.desc': '利用内地供应链优势，启动全球贸易计划，渗透全球终端存储市场。',
  'roadmap.milestone3.quarter': 'Q4 2025',
  'roadmap.milestone3.title': '终端存储渗透',
  'roadmap.milestone3.desc': '加速 USB 闪存盘、移动硬盘等终端产品在全球市场的渠道铺设。',
  'roadmap.milestone4.quarter': '2026+',
  'roadmap.milestone4.title': '加速 Axis OS 研发',
  'roadmap.milestone4.desc': '团队加速 OS 研发，加速 NAS 产品迭代',
  'roadmap.bottomLine1': 'Axis，让数据回归核心',
  'roadmap.bottomLine2': 'DATA RETURNS TO THE AXIS',

  'careers.label': 'Join Us',
  'careers.title': '人才招聘',
  'careers.description': '我们正在寻找充满热情的人才，一起打造全球领先的数据基础设施。加入我们，共同推动技术创新与产业变革。',
  'careers.position1.title': '软件工程师',
  'careers.position1.desc': '参与 Axis OS 核心系统开发，打造下一代智能存储平台。',
  'careers.position2.title': '硬件工程师',
  'careers.position2.desc': '负责存储设备与终端产品的硬件设计、测试与优化。',
  'careers.position3.title': '国际业务拓展',
  'careers.position3.desc': '开拓全球市场渠道，建立国际合作伙伴关系。',
  'careers.ctaTitle': '有意加入我们的团队？',
  'careers.ctaDesc': '请将您的履历发送至以下邮箱，我们期待与您对话。',
};